<template>
  <svg @click="$emit('click')">
    <use :xlink:href="`#${iconName}`" />
  </svg>
</template>

<script>
export default { props: { iconName: { type: String } } }
</script>

<style></style>
